import { useAppDispatch } from '@/hooks/redux';
import { removeNotification } from '@/store/slices/notificationsSlice';
import { TNotification } from '@/types/notifications';
import { useCallback, useEffect } from 'react';

export const useNotification = (notification: TNotification): {onClose: () => void} => {
    const dispatch = useAppDispatch();

    const onClose = useCallback(() => {
        dispatch(removeNotification(notification.id!));
    }, [dispatch, notification]);

    useEffect(() => {
        let timer: undefined | ReturnType<typeof setTimeout>;
        if (notification.timer) {
            timer = setTimeout(() => {
                onClose();
            }, notification.timer);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [onClose, notification]);

    return {onClose};
};
